module.exports = __webpack_public_path__ + "img/24.cf64d361.png";